<template>
  <dt-modal
    :model-value="props.showDialog"
    class="wide-modal"
    @update:model-value="val => emit('update:showDialog', val)"
  >
    <template #header>
      <h4 class="modal-title">
        📅 {{ isHolidayHours ? $t('dialog.header.holidayopeninghours') : $t('dialog.header.standardopeninghours') }}
      </h4>
    </template>

    <template #body>
      <p style="padding-left: 20px;">{{ $t('dialog.body.openinghours') }}</p>
      <p></p>
      <holiday-opening-hours v-if="isHolidayHours" :holiday-hours="openingHours" />
      <standard-opening-hours v-else :standard-hours="openingHours" />
      <p></p>
      <p class="note" style="padding-left: 20px;">
        {{ $t('dialog.body.openinghours.supportemail') }} <strong>{{ props.supportEmail }}</strong>
      </p>
    </template>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="close">
        {{ $t('popup.close') }}
      </button>
    </template>
  </dt-modal>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useStore } from 'vuex'

import DtModal from '@/components/utilities/modal/dt-modal.vue'
import HolidayOpeningHours from '@/components/openinghours/holiday-opening-hours.vue'
import StandardOpeningHours from '@/components/openinghours/standard-opening-hours.vue'

const store = useStore()

const props = defineProps({
  showDialog: { type: Boolean, default: false },
  supportEmail: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:showDialog', 'closing'])

const openingHours = computed(() => store.getters['openingHours/openingHours'])

const isHolidayHours = computed(() => {
  return (
    Array.isArray(openingHours.value) &&
    openingHours.value.length > 0 &&
    openingHours.value[0] !== null &&
    openingHours.value[0] !== undefined &&
    typeof openingHours.value[0] === 'object' &&
    'scheduledDate' in openingHours.value[0]
  )
})

function close() {
  emit('closing')
  emit('update:showDialog', false)
}
</script>

<style scoped>
.wide-modal {
  max-width: 1000px !important;
}
.note {
  margin-top: 10px;
  font-style: italic;
}
</style>
